
const What3Words = ({ what3Words }: any) => {
    return (
        <a href={`https://what3words.com/${what3Words}`} target="_blank">w3w&nbsp;///{what3Words}</a>
    )
};

export default What3Words;